
import { useState, useEffect } from "react"
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { Alert } from "@material-ui/lab";
import { useSelector, useDispatch } from "react-redux";
import EstatusCuenta from "../../../../global/EstatusCuenta";
import { formatDinero } from "./../../../../utils/formatDinero"
import { EstatusCompra } from "./../../../../constant/catEstatusCompra"
import { obtenerClienteItemsPaquete } from "./../../../../ducks/clientesDuck"
import { catTipoCompra } from "../../../../constant/catTipoCompra"
import { FormatoFechaIso } from "../../../../utils/FormatFecha";
import EstatusVoucher from "../../../../global/EstatusVoucher";
const columns = [
    { id: "item", minWidth: 50, align: "center", label: "Item" },
    { id: "monto", minWidth: 50, align: "center", label: "Monto" },
    { id: "pagado", minWidth: 50, align: "center", label: "Pagado" },
    { id: "voucher", minWidth: 50, align: "center", label: "Voucher" },
    { id: "fechaInicio", minWidth: 50, align: "center", label: "Fecha solicitud" },
    { id: "fechaPago", minWidth: 50, align: "center", label: "Fecha Pago" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
    },
    containerRootButton: {
        marginTop: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TablaCompras = () => {
    const { comprasItems, referencia } = useSelector(store => store.cliente)
    const rows = comprasItems.sort(function(a, b) {
        return Number(a?.TipoCompra?.idTipoCompra) - Number(b?.TipoCompra?.idTipoCompra)
    })
    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerClienteItemsPaquete())
    }, [dispatch])
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    if (referencia === "")
        return (
            <div className="TarjetaClienta-root">
                <div className="contenido">
                    <Alert className="alerta" severity="info">Selecciona un cliente</Alert>
                </div>
            </div>
        )
    if (rows.length > 0) return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.idCompra}>
                                        <TableCell align='center'>
                                            {`${row?.TipoCompra?.Descripcion}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${formatDinero((row?.TipoCompra?.idTipoCompra === catTipoCompra.UTILIDAD) ? row?.MontoCuenta : row?.MontoProveedor)} ${(row?.TipoCompra?.idTipoCompra === catTipoCompra.UTILIDAD) ? row?.paquete?.Cotizacion?.Moneda?.Clave : row?.paquete?.MonedaProveedor?.Clave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                (row?.estatusCompra?.idEstatusCompra !== EstatusCompra.APROBADO_CLIENTE) &&
                                                <EstatusCuenta estatus={row?.estatusCompra?.idEstatusCompra} />
                                            }
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                (row?.TipoCompra?.idTipoCompra !== catTipoCompra.UTILIDAD) &&
                                                <EstatusVoucher estatus={row?.ExisteVaucher} />
                                            }
                                                   {
                                                (row?.TipoCompra?.idTipoCompra === catTipoCompra.UTILIDAD) &&
                                                <p>No aplica</p>
                                            }
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row?.FechaRegistro, formato: "dd MMMM yyyy" })}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row?.FechaPago, formato: "dd MMMM yyyy" })}`}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )

    return (
        <div className="TarjetaClienta-root">
            <div className="contenido">
                <Alert className="alerta" severity="info">No hay compras para mostrar</Alert>
            </div>
        </div>
    )
}
export default TablaCompras